import { Component, OnInit, OnDestroy } from '@angular/core';
import { IOrgSeasonWeek } from '../../models/IOrgSeasonWeek';
import { NflService } from '../../services/nfl.service';
import { IOrg } from '../../models/IOrg';
import { BaseService } from '../../services/base.service';
import { Http } from '@angular/http';
import { AuthService } from '../../account/auth.service';
import { IGame } from '../../models/IGame';
import { IUser } from '../../models/IUser';
import { ISeason } from '../../models/ISeason';
import { IWeek } from '../../models/IWeek';
import { OrgSeasonWeekService } from '../../services/orgseasonweek.service';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-usermanager',
  templateUrl: './usermanager.component.html',
  styleUrls: ['./usermanager.component.scss']
})
export class UserManagerComponent implements OnInit, OnDestroy {


  public isRequesting: boolean = false;

  public model: IOrgSeasonWeek = { season: null, seasonType: null, week: null, org: null };
  public users: IUser[];
  public orgs: IOrg[];
  public selectedOrg: IOrg;
  public selectedUser: IUser;
  public selectedSeason: ISeason;
  public selectedWeek: IWeek;

  public seasons: ISeason[];
  public weeks: IWeek[];

  //public seasonWeeks: ISeasonWeek[] = [];
  public localTime: string;
  public serverStartDateTime: Date;
  public tieBreaker: number;
  public error: any;
  public games: IGame[];
  constructor(private nflService: NflService,
    private authService: AuthService,
    private orgSeasonWeekService: OrgSeasonWeekService,
    private baseService: BaseService) {

  }
  public orgEvent: Subscription;
  public weekEvent: Subscription;
  public seasonEvent: Subscription;
  ngOnInit() {
    this.orgEvent = this.orgSeasonWeekService.org.subscribe(org => {
      this.model.org = org;
      this.weekEvent = this.orgSeasonWeekService.season.subscribe(season => {
        this.model.season = season;
        this.seasonEvent = this.orgSeasonWeekService.week.subscribe(week => {
          this.model.week = week;
          console.log(this.model);
          this.getFootballUsers();
        });
      });
    });

  }

  ngOnDestroy(): void {
    this.orgEvent.unsubscribe();
    this.seasonEvent.unsubscribe();
    this.weekEvent.unsubscribe();
  }

  updateOrgGameScores() {
    this.isRequesting = true;
    this.nflService.updateOrgGameScores(this.model).subscribe(result => {
      this.getGames();
      this.isRequesting = false;
      //this.games = result as IGame[];
      //this.games.sort((a, b) => this.getEpochTime(a.startDateTime) - this.getEpochTime(b.startDateTime));
    })
  }
  getFootballUsers() {
    this.nflService.getNflUsers(this.model).subscribe(result => {
      this.users = result as IUser[];
      //this.users.sort((a => a.friendlyName);
      if (!this.model.userId) {
        this.model.userId = this.users[0].id;
        this.selectedUser = this.users[0];
      }
      this.getGames();
    })
  }
  updateTieBreaker(event: any) {
    var game = this.games.slice(-1)[0] as IGame;
    game.tieBreaker = event.target.value;
    this.updateOrgUserGame(game)
    this.baseService.toasterService.pop('info', 'Football User', 'Tie Breaker changed to ' + game.tieBreaker);
  }
  getGames() {
    //this.isRequesting = true
    this.nflService.getUserGames(this.model).subscribe(result => {
      this.games = result as IGame[];
      //this.games.sort((a, b) => b.points - a.points);
      this.games.sort((a, b) => this.baseService.getEpochTime(a.startDateTime) - this.baseService.getEpochTime(b.startDateTime));
      this.tieBreaker = this.games.slice(-1)[0].tieBreaker;
      // this.isRequesting = false;
    });
  }
  changePickUnderDog(game: IGame) {
    game.selected = game.underdog;
    this.updateOrgUserGame(game);
    this.baseService.toasterService.pop('info', 'Football User', 'Pick changed to ' + game.selected.name);
  }

  changePickFavorite(game: IGame) {
    game.selected = game.favorite;
    this.updateOrgUserGame(game);
    this.baseService.toasterService.pop('info', 'Football User', 'Pick changed to ' + game.selected.name);
  }
  settCurrentOrg(org: IOrg) {
    this.selectedOrg = org;
  }

  setCurrentUser(user: IUser) {
    this.model.userId = user.id;
    this.selectedUser = user;
    this.getGames();
  }

  updateOrgUserGame(game: IGame) {
    //game.orgId = this.selectedOrg.id;
    this.nflService.updateOrgUserGame(game).subscribe(result => {
      this.getGames();
    });
    // this.nflService.updateOrgGame(game).unsubscribe
  }

  localtime(gamestart: any) {
    return this.baseService.getLocalTimeFromUtc(gamestart);
  }

  allCapsFavorite(game: IGame) {
    if (game.favoriteIsHome) {
      return game.favorite.name.toUpperCase();
    }
    else
      return game.favorite.name
  }
  allCapsUnderdog(game: IGame) {
    if (game.underdogIsHome) {
      return game.underdog.name.toUpperCase();
    }
    else
      return game.underdog.name
  }

  winner(status: string, points: number) {
    if (status == 'Complete' && points > 0)
      return true;
    else
      return false;
  }


  setCurrentSeason($event: MouseEvent, season) {
    this.model.season = season.name;
    this.getGames();
    //this.getRaceResults();
    //this.getRaceSeasonResults();

  }

  setCurrentWeek($event: MouseEvent, week) {

    this.model.week = week.name;
    this.getGames();

  }
}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/nflmanager/usermanager/usermanager.component.ts